<ami-dialog-message [setting]="message"></ami-dialog-message><p-toast></p-toast>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Crear Producto No Regulado"
  [style]="{ width: '750px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="mt-3 mb-2">
          <p-fieldset
            legend="Datos"
            [toggleable]="true"
            class="mt-3 mb-2 md:mt-0"
          >
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-6">
                <label class="label-required">Código</label>
                <input pInputText formControlName="code" type="text" />
                <div
                  *ngIf="
                    fg.get('code').invalid &&
                    (fg.get('code').dirty || fg.get('code').touched)
                  "
                  class="p-invalid"
                >
                  <div *ngIf="fg.get('code').errors?.required">
                    <small class="p-error">No puede quedar vacío.</small>
                  </div>
                  <div *ngIf="fg.get('code').errors?.min">
                    <small class="p-error">Debe ser como minimo 1.</small>
                  </div>
                </div>
              </div>
              <div class="field col-12 md:col-6">
                <label class="label-required">Nombre</label>
                <input pInputText formControlName="name" type="text" />
                <div
                  *ngIf="
                    fg.get('name').invalid &&
                    (fg.get('name').dirty || fg.get('name').touched)
                  "
                  class="p-invalid"
                >
                  <div *ngIf="fg.get('name').errors?.required">
                    <small class="p-error">No puede quedar vacío.</small>
                  </div>
                  <div *ngIf="fg.get('name').errors?.minlength">
                    <small class="p-error"
                      >Debe tener una longitud mínima de 5.</small
                    >
                  </div>
                  <div *ngIf="fg.get('name').errors?.maxlength">
                    <small class="p-error"
                      >Debe tener una longitud máximma de 255.</small
                    >
                  </div>
                </div>
              </div>
              <div class="field col-12 md:col-6">
                <label>Código de barras</label>
                <input pInputText formControlName="barCode" type="text" />
                <div
                  *ngIf="
                    fg.get('barCode').invalid &&
                    (fg.get('barCode').dirty || fg.get('barCode').touched)
                  "
                  class="p-invalid"
                >
                  <div *ngIf="fg.get('barCode').errors?.required">
                    <small class="p-error">No puede quedar vacío.</small>
                  </div>
                  <div *ngIf="fg.get('barCode').errors?.minlength">
                    <small class="p-error"
                      >Debe tener una longitud mínima de 5.</small
                    >
                  </div>
                  <div *ngIf="fg.get('barCode').errors?.maxlength">
                    <small class="p-error"
                      >Debe tener una longitud máximma de 32.</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </p-fieldset>
        </div>
      </form>
      <div>
        <div>
          <div class="card">
            <p-fieldset legend="Formato de Venta" [toggleable]="true">
              <div class="p-fluid p-formgrid">
                <p-table
                  [value]="hierarchyFormats"
                  dataKey="id"
                  editMode="row"
                  responsiveLayout="scroll"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Nombre</th>
                      <th>Sub Formato</th>
                      <th>Cantidad S.F</th>
                      <th>FV</th>
                      <th>FMV</th>
                      <th>FC</th>
                      <th style="width: 8rem"></th>
                    </tr>
                  </ng-template>
                  <ng-template
                    pTemplate="body"
                    let-format
                    let-editing="editing"
                    let-ri="rowIndex"
                  >
                    <tr [pEditableRow]="format">
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <input
                              pInputText
                              type="text"
                              [disabled]="disabled"
                              [(ngModel)]="format.nombre"
                            />
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{ format.nombre }}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <input
                              pInputText
                              type="text"
                              [disabled]="format.isFormatSaleMin"
                              [(ngModel)]="format.subFormat"
                            />
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{ format.subFormat }}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <p-inputNumber
                              inputId="integeronly"
                              [disabled]="format.isFormatSaleMin"
                              [(ngModel)]="format.cantidad"
                              [min]="1"
                            >
                              >
                            </p-inputNumber>
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{ format.cantidad }}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <p-toggleButton
                              [(ngModel)]="format.isFormatSale"
                              onIcon="pi pi-check"
                              offIcon="pi pi-times"
                            ></p-toggleButton>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <i
                              [ngClass]="
                                format.isFormatSale === true
                                  ? 'pi pi-check'
                                  : 'pi pi-times'
                              "
                              style="font-size: 2rem"
                            ></i>
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <p-toggleButton
                              [(ngModel)]="format.isFormatSaleMin"
                              (click)="cambiarCheck(ri)"
                              onIcon="pi pi-check"
                              offIcon="pi pi-times"
                            ></p-toggleButton>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <i
                              [ngClass]="
                                format.isFormatSaleMin === true
                                  ? 'pi pi-check'
                                  : 'pi pi-times'
                              "
                              style="font-size: 2rem"
                            ></i>
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <p-toggleButton
                              [(ngModel)]="format.isFormatPurchase"
                              onIcon="pi pi-check"
                              offIcon="pi pi-times"
                            ></p-toggleButton>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <i
                              [ngClass]="
                                format.isFormatPurchase === true
                                  ? 'pi pi-check'
                                  : 'pi pi-times'
                              "
                              style="font-size: 2rem"
                            ></i>
                          </ng-template>
                        </p-cellEditor>
                      </td>

                      <td style="text-align: center">
                        <button
                          *ngIf="!editing"
                          pButton
                          pRipple
                          type="button"
                          pInitEditableRow
                          icon="pi pi-pencil"
                          (click)="onHierarchyRowEdit(format)"
                          class="p-button-rounded p-button-text"
                        ></button>
                        <button
                          *ngIf="editing"
                          pButton
                          pRipple
                          type="button"
                          pSaveEditableRow
                          icon="pi pi-check"
                          (click)="onHierarchyRowEditSave(format)"
                          class="p-button-rounded p-button-text p-button-success mr-2"
                        ></button>
                        <button
                          *ngIf="editing"
                          pButton
                          pRipple
                          type="button"
                          pCancelEditableRow
                          icon="pi pi-times"
                          (click)="onHierarchyRowEditCancel(format, ri)"
                          class="p-button-rounded p-button-text p-button-danger"
                        ></button>
                      </td>
                      <td style="text-align: center">
                        <button
                          *ngIf="
                            ri == hierarchyFormatLength &&
                            !hierarchyFormats[hierarchyFormatLength]
                              .isFormatSaleMin
                          "
                          (click)="hierarchyAddRow(ri)"
                          pButton
                          type="button"
                          class="p-button-success"
                          icon="pi pi-plus-circle"
                        ></button>
                      </td>
                      <td style="text-align: center">
                        <button
                          *ngIf="ri == hierarchyFormatLength && ri > 0"
                          (click)="hierarchyDeleteRow()"
                          pButton
                          type="button"
                          class="p-button-danger"
                          icon="pi pi-minus-circle"
                        ></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </p-fieldset>
          </div>

          <div class="p-fluid p-formgrid grid mt-3 mb-2">
            <div class="field col-12 md:col-8"></div>
            <div class="field col-12 md:col-2">
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-times"
                (click)="onClose()"
                class="p-button-text"
                label="No"
                pTooltip="Cancelar Cambios"
                tooltipPosition="top"
              ></button>
            </div>
            <div class="field col-12 md:col-2">
              <button
                type="button"
                (click)="onSubmit()"
                pButton
                [disabled]="
                  !(fg.valid && hasPurchaseFormat && hasMinSaleFormat)
                "
                pRipple
                icon="pi pi-check"
                class="p-button-text"
                label="Si"
                tooltipPosition="top"
                pTooltip="Guardar Cambios"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div></div
></p-dialog>
